import React from 'react';

export class FormInputContainerComponent extends React.Component {
    render() {
        const { className } = this.props;
        return (
            <div className={`form-input-container ${className ? className : ''}`}>
                {this.props.children}
            </div>
        );
    }
}

export class ItemComponent extends React.Component {
    render() {
        const { className, children } = this.props;
        return <div className={className ? className : ''}>{children ? children : null}</div>;
    }
}
/**
 * TODO: au lieu de mettre chaque attr (readOnly, disabled, maxLength...) mettre à la place un objet attrs et appliquer les attributs sur l'input
 */
export class InputComponent extends React.Component {
    render() {
        const {
            input,
            type,
            placeholder,
            label,
            className,
            meta,
            readOnly,
            onChange,
            disabled,
            maxLength,
            min,
            max,
            isRequired,
            autoComplete,
            tooltip
        } = this.props;

        const hasError = meta.touched && meta.error;
        const describedBy =
            [
                hasError ? `error-${input.name}-${meta.form}` : null,
                tooltip ? `tooltip-${input.name}-${meta.form}` : null
            ]
                .filter(Boolean)
                .join(' ') || undefined;
        return (
            <input
                {...input}
                type={type}
                id={`${input.name}-${meta.form}`}
                ref="input"
                placeholder={placeholder ? placeholder : label ? label : ''}
                className={`input ${className ? className : ''} ${
                    hasError ? 'input-error' : ''
                }`}
                readOnly={readOnly}
                disabled={disabled}
                onChange={onChange ? onChange : input.onChange}
                maxLength={maxLength}
                min={min}
                max={max}
                autoComplete={autoComplete}
                aria-required={isRequired}
                aria-invalid={hasError ? 'true' : undefined}
                aria-describedby={describedBy}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/form/InputWrappersComponent.js